import React from 'react'
import { List } from 'immutable'
import { Button, Grid } from '@material-ui/core'
import { ILocalizedLanguage } from 'store/locale/types'
import { Image } from 'components/ui/DataDisplay/Image'
import { Link } from 'components/ui/Behaviors/Link'
import { LanguageSelector } from 'components/ui/DataFilter/LanguageSelector'
import { MenuListButtonGroup } from './MenuListButtonGroup'
import { useStyles } from './LargeScreenNavigationBar.styles'
import { IImage } from 'hooks/useImages'
import { IMenuItem } from 'hooks/useMenu'

interface ILargeScreenNavigationBarProps {
  logo: IImage
  topMenuItems: List<IMenuItem>
  menuItems: List<IMenuItem>
  selectedLanguage: string
  languages: List<ILocalizedLanguage>
  onSelectLanguage: (language: string) => void
}

export const LargeScreenNavigationBar = ({
  logo,
  onSelectLanguage,
  selectedLanguage,
  languages,
  menuItems,
  topMenuItems
}: ILargeScreenNavigationBarProps) => {
  const classes = useStyles()

  return (
    <>
      <Grid item container md={1} alignItems={'center'} className={classes.logoLinkWrapper}>
        <Link route={logo.link}>
          <Image height={'2rem'} ratio={2.42} backgroundUrl={logo.url} highlightable={false} />
        </Link>
      </Grid>
      <Grid container className={classes.root}>
        <Grid
          item
          container
          md={12}
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          className={classes.innerNavWrapper}
        >
          <Grid item container direction="row" justifyContent="flex-end" alignItems="center" xs={1} md={12}>
            <Grid className={classes.linkContainer} item container md={5} spacing={1}>
              {topMenuItems.map(({ link, title, isButton }, index) => (
                <Grid key={index} item xs={8} md={12} className={classes.linkItem}>
                  {isButton ? (
                    <Button variant={'outlined'} className={classes.button}>
                      <Link route={link}>{title}</Link>
                    </Button>
                  ) : (
                    <div className={classes.borderlessItem}>
                      <Link route={link}>{title}</Link>
                    </div>
                  )}
                </Grid>
              ))}
              <Grid item xs={8} md={12} className={classes.borderlessItem}>
                <LanguageSelector active={selectedLanguage} languages={languages} onSelect={onSelectLanguage} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container md={10} alignItems={'center'} className={classes.navEntrieWrapper}>
            <Grid item container xs={1} md={12} direction="row" justifyContent="flex-start" alignItems="flex-start">
              <MenuListButtonGroup menuItems={menuItems} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
